import { lineColors } from "../../../utils";

export const LOCATIONS_LAYER = {
  id: "locations",
  type: "circle",
  source: "locations",
  layout: {
    visibility: "visible",
  },
  paint: {
    "circle-radius": [
      "interpolate",
      ["linear"],
      ["zoom"],

      // At zoom level 5
      5,
      [
        "case",
        ["boolean", ["feature-state", "selected"], false],
        9, // Larger if selected
        3, // Default size
      ],

      // At zoom level 11
      11,
      [
        "case",
        ["boolean", ["feature-state", "selected"], false],
        13, // Larger if selected
        7, // Default size
      ],

      // At zoom level 15
      15,
      [
        "case",
        ["boolean", ["feature-state", "selected"], false],
        19, // Larger if selected
        14, // Default size
      ],
    ],
    "circle-color": [
      "case",
      ["boolean", ["feature-state", "selected"], false],
      lineColors.yellow, // Yellow when selected
      lineColors.lightBlue, // Default color
    ],
    "circle-stroke-width": [
      "case",
      ["boolean", ["feature-state", "selected"], false],
      4, // Thicker stroke for selected
      1, // Default stroke
    ],
    "circle-stroke-color": [
      "case",
      ["boolean", ["feature-state", "selected"], false],
      "#FFFFFF", // White stroke when selected
      "#000", // Default stroke
    ],
  },
  lreProperties: {
    popup: {
      titleField: "well_ndx",
      customLabels: {
        well_id: "SWN/District ID",
        well_status: "Status",
        well_class: "Classification",
        well_subclass: "Subclassification",
        primary_use: "Use Type",
        lat_dd: "Latitude",
        lon_dd: "Longitude",
        owner_info: "Owner",
      },
      customFields: [
        {
          label: "Pumpage Report",
          value: "/forms/pumpage-report?permit_ndx={assoc_permit_ndx}",
          displayText: "Link",
          type: "url",
        },
        {
          label: "Water Level Records",
          value: "/forms/water-level-records?well_ndx={well_ndx}",
          displayText: "Link",
          type: "url",
        },
      ],
      sortOrder: ["Pumpage Report", "Water Level Records"],
      excludeFields: ["well_ndx", "geometry"],
      adminOnlyFields: ["auth0_user_id"],
    },
  },
};

export const LOCATIONS_LABELS_LAYER = {
  id: "locations-labels",
  type: "symbol",
  source: "locations",
  // minzoom: 12,
  visibility: "visible",
  layout: {
    visibility: "visible",
    "symbol-placement": "point",
    "text-field": ["get", "well_ndx"],
    "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
    "text-size": 14,
    "text-anchor": "center",
    "text-offset": [0, -1],
    "text-justify": "center",
  },
  paint: {
    "text-color": "#1a1a1a",
    "text-halo-color": "rgba(255, 255, 255, 0.9)",
    "text-halo-width": 2,
    "text-halo-blur": 0.1,
  },
};

export const BASEMAP_STYLES = [
  { url: "satellite-streets-v11", icon: "satellite_alt" },
  { url: "outdoors-v11", icon: "park" },
  { url: "streets-v11", icon: "commute" },
];

export const DEFAULT_MAP_CENTER = [-98.00408, 30.10119];
export const DEFAULT_MAP_ZOOM = 8.5;
export const DEFAULT_MAP_BASEMAP =
  "mapbox://styles/mapbox/" + BASEMAP_STYLES[0].url;

export const INIT_MAP_CONFIG = {
  style: DEFAULT_MAP_BASEMAP,
  center: DEFAULT_MAP_CENTER,
  zoom: DEFAULT_MAP_ZOOM,
  preserveDrawingBuffer: true,
  attributionControl: true,
};
